<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">Gestión de Facturas / Remitos</v-toolbar-title>
                            <v-spacer></v-spacer>
                            EI 040
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> N° de Orden de Compra: {{ codoc }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Fecha de Orden de Compra: {{ fecha }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="8" md="10">
                                    <v-textarea dense v-model="descr" rows="2" auto-grow readonly outlined color="black"
                                        class="font-class-name"></v-textarea>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense v-model="cantidad" label="Catidad de Entregas" outlined readonly
                                        color="red darken-3"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="2" md="2">

                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-btn v-if="this.numot != null && this.numot != ''" color="success"
                                        @click.stop="pendientellegada()">Materiales
                                        Pendientes
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Tarjeta para mostrar cada elemento -->
                    <v-card>
                        <v-card-text>
                            <v-row dense v-for="(item, index) in listado" :key="index">
                                <v-col cols="12" sm="6" md="2">
                                    Entrega: {{ item.entrega }}
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field dense v-model="item.facturaadm" label="Factura" outlined
                                        color="red darken-3"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-text-field dense v-model="item.remitoadm" label="Remito" outlined
                                        color="red darken-3"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-select dense label="Estado Entrega" v-model="item.estadoadm" :items="estados"
                                        item-text="nombre" item-value="valor" outlined class="font-class-name"
                                        color="black"></v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-select color="red darken-3" dense v-model="estado" :items="listadoestado"
                                        label="Estado" item-text="nombre" item-value="valor">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#d98880" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
                <Pendiente :visible="showPendiente" :numotdesde="this.numot.substring(0, 5)"
                    :numothasta="this.numot.substring(8, 13)" @close="showPendiente = false">
                </Pendiente>
            </v-app>
        </div>
    </v-dialog>
</template>
<style scoped>
.font-class-name {
    font-size: 14px;
}

.font-class-bulto {
    font-size: 11px;
}
</style>
<style lang="scss" scoped>
.v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 0px !important;

    label {
        margin: 0 !important;
        margin-bottom: 0 !important;
    }

}

.v-textarea textarea {
    line-height: 0.5rem !important;
    margin: 1px;
}
</style>
<script>
import moment from "moment";
import Pendiente from "../Lanzamiento/Pendientellegada.vue";
import axios from "../../axios-auth";
export default {
    components: { Pendiente },
    data() {
        return {
            showPendiente: false,
            valid: false,
            lazy: false,
            empresa: "",
            provision: "",
            descr: "",
            fecha: "",
            cantidad: "",
            tipo: "",
            listado: [],
            listadoadmin: [],
            estado: "",
            listadoestado: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            headers: [
                { text: "Entrega", value: "entrega", sortable: false, width: "5%" },
                { text: "Item", value: "item", sortable: false },
                { text: "Tipo y Cantidad de Camiones", value: "camion", sortable: false, width: "25%" },
                { text: "Total de Bultos", value: "bultos", sortable: false, width: "7%" },
                { text: "Estado", value: "estado", sortable: false, width: "15%" },

            ],
            deshabilitar: false,
            expanded: [],
            direcciones: [],
            direccion: "",
            correos: "",
            destinatarios: [],
            montoasegurado: "",
            poliza: "",
            pendientereserva: 0,
        };
    },
    watch: {
        'listado': {
            handler() {
                this.checkPendienteReserva();
            },
            deep: true, // Escuchar cambios dentro de los elementos de la lista
        },
        pendientereserva: 'checkPendienteReserva',
        estado: 'checkPendienteReserva',
    },

    props: ["visible", "codgral", "codoc", "numot"],
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },

    },

    methods: {
        checkPendienteReserva() {
            if ((this.listado.some(item => item.estadoadm === 'C') || this.estado == "C") && this.pendientereserva > 0) {
                this.deshabilitar = true
                this.showAlert2({
                    icon: "error",
                    title: "No puede Cerrar con Materiales Reservados",
                    vm: this,
                    time: "5500",
                });
            }
            else {
                this.deshabilitar = false
            }
        },

        showAlert2(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: alertInfo.time,
            });
        },

        cargardatos() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let numotdesde = "";
            let numothasta = "";
            if (this.numot != "" && this.numot != null) {
                numotdesde = this.numot.substring(0, 5);
                numothasta = this.numot.substring(8, 13);
            }

            let self = this;
            axios
                .get("/Lanzamiento/CargarAdministracion?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.empresa = response.data.empresa;
                    self.provision = response.data.provision;
                    self.fecha = response.data.fecha;
                    self.estado = response.data.estado;
                    self.cantidad = response.data.cantidad;
                    self.tipo = response.data.tipo;
                    self.descr = response.data.descr;
                    self.listado = response.data.despacho;
                }
                )
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });

            axios
                .get("/Lanzamiento/ListadoPendientereserva?", {
                    params: {
                        numotdesde: numotdesde,
                        numothasta: numothasta,
                    },
                })
                .then((response) => {
                    self.pendientereserva = response.data.length;
                    console.log("TAMAÑO ARREGLO ", self.pendientereserva)
                })
                .catch((error) => {
                    self.pendientereserva = 0;
                    console.log(error);
                });
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Datos Factura/Remito",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.listado.forEach((element) => {
                        //if ((element.facturaadm != "" && element.facturaadm != null) || (element.remitoadm != "" && element.remitoadm != null)) {
                        this.listadoadmin.push({
                            codgral: this.codgral,
                            codoc: this.codoc,
                            entrega: element.entrega,
                            factura: element.facturaadm,
                            remito: element.remitoadm,
                            estado: element.estadoadm,
                        });
                        //}
                    });
                    var datos = {
                        codoc: this.codoc,
                        codgral: this.codgral,
                        empresa: this.empresa,
                        tipo: this.tipo,
                        estado: this.estado,
                        admin: this.listadoadmin,
                    };

                    let self = this;
                    console.log("ADMIN", this.listadoadmin)
                    axios
                        .post("/Lanzamiento/GuardarAdministracion", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Planilla guardada con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            // setTimeout(() => {
                            //     self.$router.push({ name: "LanzamientoMain" });
                            // }, 5000);
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 7000,
            });
        },

        vaciarListado() {
            this.empresa = "";
            this.fecha = "";
            this.provision = "";
            this.descr = "";
            this.tipo = "";
            this.cantidad = "";
            this.listado = [];
            this.listadoadmin = [];
            this.estado = "";
            this.direccion = "";
            this.correos = "";
            this.direcciones = [];
            this.deshabilitar = false;

        },
        pendientellegada() {
            this.showPendiente = true;
        },
    },
};
</script>
